import React, { Component } from 'react';

export default class NoData extends Component {
  render() {
    return <small style={{textAlign:"center",color:"red"}}>No Data Found</small>;
  }
}
